import { useState, useMemo, useCallback } from 'react';
import { useDndMonitor } from '@dnd-kit/core';
import { EventColorMapper, EventColorSet } from '../utils/eventColors';
import { CalendarEvent } from '../utils/eventUtils';

export interface HoveredCardData {
  event: CalendarEvent;
  rect: DOMRect;
  colorSet: EventColorSet;
}

interface UseWeekViewReturn {
  hoveredCard: HoveredCardData | null;
  setHoveredCard: (data: HoveredCardData | null) => void;
  isDragging: boolean;
  getColorSet: (event: CalendarEvent) => EventColorSet;
}

export const useWeekView = (): UseWeekViewReturn => {
  const [hoveredCard, setHoveredCard] = useState<HoveredCardData | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const colorMapper = useMemo(() => new EventColorMapper(), []);

  useDndMonitor({
    onDragStart: () => {
      setHoveredCard(null);
      setIsDragging(true);
    },
    onDragEnd: () => setIsDragging(false),
    onDragCancel: () => setIsDragging(false),
  });

  const getColorSet = useCallback(
    (event: CalendarEvent): EventColorSet => {
      return colorMapper.getColorForEvent(event.title);
    },
    [colorMapper],
  );

  return {
    hoveredCard,
    setHoveredCard,
    isDragging,
    getColorSet,
  };
};
